// apps/canifight/src/components/InstallBanner.jsx
// PWA install prompt — works automatically on Chrome Android,
// shows manual instructions on iOS
import { useState, useEffect } from 'react';
import styles from './InstallBanner.module.css';

export default function InstallBanner() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [show, setShow] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    const ios = /iphone|ipad|ipod/i.test(navigator.userAgent);
    const standalone = window.navigator.standalone;
    setIsIOS(ios);

    if (ios && !standalone) {
      setTimeout(() => setShow(true), 4000);
    }

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setTimeout(() => setShow(true), 3000);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      await deferredPrompt.userChoice;
      setDeferredPrompt(null);
      setShow(false);
    }
  };

  if (!show) return null;

  return (
    <div className={styles.banner}>
      <div className={styles.icon}>📲</div>
      <div className={styles.text}>
        <strong>Install Can I Fight It?</strong>
        <span>
          {isIOS
            ? 'Tap Share → Add to Home Screen'
            : 'Add to home screen for the full app experience'}
        </span>
      </div>
      {!isIOS && (
        <button className={styles.installBtn} onClick={handleInstall}>INSTALL</button>
      )}
      <button className={styles.dismiss} onClick={() => setShow(false)}>✕</button>
    </div>
  );
}
